var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-16"},[_vm._m(0),_c(_vm.currentService,{tag:"component"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"items-center justify-center text-center"},[_c('h2',{staticClass:"text-6xl font-semibold text-main-text mb-5"},[_vm._v("Services")]),_c('hr',{staticClass:"w-20 h-1 mx-auto my-4 -mt-3 bg-main-orange border-0 rounded md:my-6 dark:bg-gray-700"})])
}]

export { render, staticRenderFns }